import Util from "@/components/js/util.js";
import axios from "axios";
import { do_ } from "@/api/index";
import dlgFunc from "../../views/textProofreading/index.js";
import { addTextSelectionColor, confidenceName } from "../../utils/common.js";
import storage from "../auth";
import { login } from "@/api/user";
export default {
  data() {
    return {
      errorStatistics: {
        list: [],
      },
      loading: false, // 校对中
      percentage: 0, //进度条值
      timeStart: "", //进度条计
      isContinue: true, // 暂停（false）或继续(true)
      currentTime: {
        interval: null,
        second: 0,
        time: "",
      },
      estimated: {
        interval: null,
        time: 0,
      },
      // 被暂停
      interrupted: {
        data: [],
        item: [],
      },
      radio: null,
      proofreading: null,
      errorTypeCoun: 0,
    };
  },
  computed: {
    // total() {
    //   // const number = this.errorStatistics.list.reduce((prev, curr) => {
    //   //   const { appearTotal = 0 } = curr;
    //   //   // console.log(prev,  appearTotal)
    //   //   return prev + appearTotal;
    //   // }, 0);
    //   // return number;
    // },
  },
  created() {
    this.$nextTick(() => {
      const isContinue = wps.PluginStorage.getItem("isContinue");
      this.isContinue = isContinue || this.isContinue;
      this.loading = true;
      this.radio = localStorage.getItem("radio");
      this.proofreading = localStorage.getItem("proofreading");
      this.inspect();
    });
  },
  watch: {
    // 监听loading状态控制进度条显示
    loading(value, newValue) {
      const that = this;
      if (value) {
        that.increase();
        that.startTime();
      } else {
        that.increaseend();
        this.stopTiming();
      }
    },
  },
  methods: {
    /**
     * 校对
     * obj 段落或句子对象
     * count 总数
     */
    async getProofreading(obj, count) {
      const { domains, wps } = localStorage;
      const {
        user: { pwd, userid },
      } = JSON.parse(wps);
      const all = dlgFunc.CWps.Application.ActiveDocument.Range();
      // 上次校验被暂停的
      const breakLine = Number(localStorage.getItem("breakLine"));
      const all_end = all.End;

      let data = breakLine ? this.errorStatistics.list : [];
      const { radio, proofreading } = this;

      this.estimated.time = this.estimated.time
        ? this.estimated.time
        : Math.floor(all_end / 200);
      this.startEstimated();

      let paramsArray = [];
      for (let index = breakLine || 0; index < count; index++) {
        const findItem = obj.Item(index + 1);
        const item = setingDefault.splittype == 1 ? findItem.Range : findItem;
        // 空格转换
        const text = item.Text.replace(/\s/g,"%20");
        const reg = /^\s+$/g;

        if (!reg.test(text)) {
          let params = {
            method: "correct",
            text: text.replace(/\r|\n/,""),
            domains: domains,
            error_types: "[7001|7002]",
            strict_degree: proofreading == 1 ? "l" : "h",
            ukey: pwd,
            userid: userid,
          };
          // 综合校对
          if (radio === "radio2") {
            params = {
              ...params,
              method: "proofread",
              domains: "ALL",
              strict_degree: proofreading == 1 ? "l" : "h",
            };
          }
          paramsArray.push({ params, item, index });
        }
      }
    // const {token} = JSON.parse(localStorage.wps);
    // const tokens = await isInspectionToken({token: token});
    let my_params = {
      userid: userid,
      pwd: pwd,
      authedkey: 'web',
      call_time: new Date().getTime(),
    }
    const check_user_time = await login(my_params);
    if (check_user_time.ret_code === '1') {
        alert('检查到您的账号异常！请重新登录');
          delete storage.token;
          delete storage.user;
        window.close();
    }else{
      storage.token = check_user_time.token
    }
      const launchNumber = 6;
      const num = Math.ceil(paramsArray.length / launchNumber);
      for (let i = 0; i < num; i++) {
        const api = [];
        if (i * launchNumber < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber].params));
        }
        if (i * launchNumber + 1 < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber + 1].params));
        }
        if (i * launchNumber + 2 < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber + 2].params));
        }
        if (i * launchNumber + 3 < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber + 3].params));
        }
        if (i * launchNumber + 4 < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber + 4].params));
        }
        if (i * launchNumber + 5 < paramsArray.length) {
          api.push(do_(paramsArray[i * launchNumber + 5].params));
        }
        if (!this.isContinue) {
          localStorage.setItem(
            "breakLine",
            paramsArray[i * launchNumber].index
          );
          break;
        }
        if (api.length === 1) {
          const list = await api[0];
          this.addColor(paramsArray, list, paramsArray.length - 1, launchNumber);
        } else {
          await axios
            .all(api)
            .then(
              axios.spread((...arg) => {
                this.addColor(paramsArray, arg, i, launchNumber);
              })
            )
            .catch((err) => {
              console.log("err--", err);
            });
        }
      }

      if (this.isContinue) {
        localStorage.setItem("breakLine", "");
        this._errorClassCount();
        this.stop();
      }
    },
    addColor(paramsArray, array = [], apiNumber, launchNumber) {
      if (!Array.isArray(array))return false;
      array = array.reduce((prev, curr, index) => {
        if(Array.isArray(curr) && curr.length > 0) {
          curr = curr.map((child) => {
            const obj = paramsArray[apiNumber * launchNumber + index].item;
            const { Start, Text, End } = obj;
            const pageNo = obj.Information(1);
            const rowNumber = obj.Information(10);

            const { offset, error_word } = child;
            const start_ = offset + Start;
            const end_ = offset + Start + error_word.length;
            const Child_ = {
              ...child,
              originalSentenceStart: Start,
              originalSentenceEnd: End,
              text: Text,
              start: start_,
              errorTypeName: confidenceName(child),
              end: end_,
              pageNo,
              rowNumber,
            };

            addTextSelectionColor(
              Child_
            );
            return Child_;
          });
          prev.push(curr);
        }
        if(curr.error_word) {
          const obj = paramsArray[apiNumber].item;
            const { Start, Text, End } = obj;
            const pageNo = obj.Information(1);
            const rowNumber = obj.Information(10);

            const { offset, error_word } = curr;
            const start_ = offset + Start;
            const end_ = offset + Start + error_word.length;
            const Child_ = {
              ...curr,
              originalSentenceStart: Start,
              originalSentenceEnd: End,
              text: Text,
              start: start_,
              errorTypeName: confidenceName(curr),
              end: end_,
              pageNo,
              rowNumber,
            };

            addTextSelectionColor(
              Child_
            );
            prev.push(Child_);
        }
        return prev;
      }, []);

      this.errorStatistics.list = this.errorStatistics.list.concat(...array);
      localStorage.setItem(
        "errorStatistics",
        JSON.stringify(this.errorStatistics)
      );
    },
    showErrata() {
      dlgFunc.CWps.ShowDialog(
        Util.GetUrlPath() + "errata",
        "勘误表",
        300 * window.devicePixelRatio,
        300 * window.devicePixelRatio,
        true
      );
    },
    /**
     * type 值含有“敏感词”3个字的（文章中标记紫色部分内容），为敏感词；
     * confidence 值大于0.85（文章中标记红色部分内容），为错词；
     * confidence值小于等于0.85（文章中标记黄色部分内容），为疑词；
     */
    _errorClassCount() {
      let dataList = this.errorStatistics.list;
      if (!dataList || dataList.length <= 0) {
        return;
      }
      let mgc = 0; //敏感词
      let cc = 0; //错词
      let yc = 0; // 疑词
      for (var i = 0; i < dataList.length; i++) {
        if (dataList[i].type.indexOf("敏感词") > 0) {
          mgc++;
        }
        if (
          dataList[i].type.indexOf("敏感词") < 0 &&
          dataList[i].confidence > 0.85
        ) {
          cc++;
        }
        if (dataList[i].confidence <= 0.85) {
          yc++;
        }
      }

      let res = 0;
      if (mgc > 0) {
        res++;
      }
      if (cc > 0) {
        res++;
      }
      if (yc > 0) {
        res++;
      }
      this.errorTypeCount = res;
    },
    startEstimated() {
      this.estimated.interval = setInterval(() => {
        const { time } = this.estimated;
        if (time === 0) {
          clearInterval(this.estimated.interval);
        } else {
          this.estimated.time = time - 1;
        }
      }, 1000);
    },
    startTime() {
      this.currentTime.interval = setInterval(() => {
        const { second } = this.currentTime;
        const num = second + 1;
        var min = Math.floor(num % 3600); //分钟
        const time =
          Math.floor(num / 3600) +
          "时" +
          Math.floor(min / 60) +
          "分" +
          (num % 60) +
          "秒";

        this.currentTime = {
          ...this.currentTime,
          second: num,
          time,
        };
      }, 1000);
    },
    stopTiming() {
      clearInterval(this.currentTime.interval);
      clearInterval(this.estimated.interval);
    },
    combined() {
      const { data } = this.interrupted;
      const { list } = this.errorStatistics;
      const lists = [...data, ...list];
    },

    increase() {
      const that = this;
      that.timeStart = setInterval(() => {
        if (that.percentage < 95) {
          that.percentage += 2;
        }
        if (that.percentage > 100) {
          that.percentage = 100;
        }
      }, 1000);
    },
    increaseend() {
      this.percentage = 100;
      clearInterval(this.timeStart);
    },
    // 暂停或继续校验
    handlerSuspend() {
      this.isContinue = !this.isContinue;
      wps.PluginStorage.setItem("isContinue", this.isContinue);

      // 是否继续
      if (this.isContinue) {
        this.increase();
        this.startTime();
        this.inspect();
      } else {
        this.stopTiming();
        clearInterval(this.timeStart);
      }
    },
    // 停止校验并显示结果
    hanldeStop() {
      this.loading = false;
      this.isContinue = false;
      wps.PluginStorage.setItem("isContinue", this.isContinue);
    },
    stop() {
      this.stopTiming();
      this.estimated.time = 0;
      wps.PluginStorage.setItem("isContinue", true);
      this.isContinue = true;
      this.percentage = 100;
      this.loading = false;
    },
    close() {
      window.close();
    },
  },
};
